var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRailcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66663 8C3.66663 6.34315 5.00977 5 6.66663 5H18.6666C20.3235 5 21.6666 6.34315 21.6666 8V16C21.6666 17.6569 20.3235 19 18.6666 19H6.66663C5.00977 19 3.66663 17.6569 3.66663 16V8Z",
    fill: "#F8E937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98395 8H11.8887L15.8693 9.89642H18.6666V11.2101H15.8693L12.4896 12.8013H18.6666V14.1358H12.4896L16.5057 16H13.5552L9.6067 14.1358H6.66663V12.8013H9.6067L13.0036 11.2101H6.66663V9.89642H13.0036L8.98395 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailcard);
export default __webpack_public_path__ + "static/media/railcard.7f7fa89d.svg";
export { ForwardRef as ReactComponent };